export class Language {
  public static readonly English = new Language('en', 'English');
  public static readonly French = new Language('fr', 'French');
  public static readonly German = new Language('de', 'Deutsch');
  public static readonly Spanish = new Language('es', 'Español');
  public static readonly Polish = new Language('pl', 'Polskie');
  public static readonly Portuguese = new Language('pt', 'Português');
  public static readonly Dutch = new Language('nl', 'Dutch');
  public static readonly Japanese = new Language('jp', 'Japanese');

  public static readonly languageCodeMap = {
    en: Language.English,
    fr: Language.French,
    de: Language.German,
    es: Language.Spanish,
    pl: Language.Polish,
    pt: Language.Portuguese,
    nl: Language.Dutch,
  };

  public static readonly ALL = Object.values(Language.languageCodeMap);

  private constructor(
    public readonly code: LanguageCode,
    public readonly name: LanguageName
  ) {}
}

export const { English, French, Spanish, German, Polish, Portuguese, Dutch, Japanese } = Language;
